import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserWaiting"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 3C12.5711 3 14.25 4.67893 14.25 6.75C14.25 8.82107 12.5711 10.5 10.5 10.5C8.42893 10.5 6.75 8.82107 6.75 6.75C6.75 4.67893 8.42893 3 10.5 3ZM10.5 1.5C7.6005 1.5 5.25 3.85051 5.25 6.75C5.25 9.6495 7.6005 12 10.5 12C13.3995 12 15.75 9.6495 15.75 6.75C15.75 3.85051 13.3995 1.5 10.5 1.5ZM8.25 15H9.75V13.5H8.25C5.35051 13.5 3 15.8505 3 18.75V22.5H4.5V18.75C4.5 16.6789 6.17893 15 8.25 15ZM16.5 12C13.6005 12 11.25 14.3505 11.25 17.25C11.25 20.1495 13.6005 22.5 16.5 22.5C19.3995 22.5 21.75 20.1495 21.75 17.25C21.75 14.3505 19.3995 12 16.5 12ZM16.5 13.5C14.4289 13.5 12.75 15.1789 12.75 17.25C12.75 19.3211 14.4289 21 16.5 21C18.5711 21 20.25 19.3211 20.25 17.25C20.25 15.1789 18.5711 13.5 16.5 13.5ZM15.75 17.5525L17.9527 19.8128L18.9628 18.8751L17.0878 16.9964V14.25H15.75V17.5525Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserWaiting.vue"]]);
